<template>
    <app-dialog :title="$t('layout.attention')" v-bind="$attrs" :isAlertDialog="true" @input="onDialogInput">
        <template v-slot:content>
            <div class="pt-12 px-3 py-3 font-size-lg dark-red-color" data-cy="app-dialog-alert-text" v-html="tHtml(html)"></div>
        </template>

        <template v-slot:buttons="{}">
            <v-btn text class="myprovet-btn-ok" @click="onCloseDialog" data-cy="app-dialog-alert-confirm-btn"> OK </v-btn>
        </template>
    </app-dialog>
</template>

<script>
import { axios } from '@/Services/Backend';

export default {
    props: {
        url: {
            type: String,
            default: '',
        },

        message: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            html: null,
        };
    },

    created() {
        if (this.url !== '') this.getMessage();
    },

    watch: {
        message: {
            handler: function (value) {
                if (value !== '') this.html = value;
            },
            immediate: true,
        },
    },

    methods: {
        onCloseDialog() {
            this.$emit('on-cancel', false);
        },

        onDialogInput() {
            this.$emit('on-cancel', false);
        },

        getMessage() {
            axios
                .get(this.url)
                .then((response) => {
                    this.html = response.data;
                })
                .catch((error) => {
                    console.log(error);
                    this.showError(this.$t('orders.pending.alertLoadError'));
                });
        },
    },
};
</script>
